import React, { useEffect, useState } from "react";
import {
  AccountCard,
  Backdrop,
  Button,
  CopyToClipboard,
  CustomSearchNew,
  LogoLoader,
  Modal,
  showToast,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import AddAccount from "./Modals/AddAccount";
import { useDispatch, useSelector } from "react-redux";
import {
  getRaSettingsStart,
  addJobStart,
} from "../../../../redux/slices/leads/leadsSlice";
import { debounce } from "lodash";
import {
  addCompanyApi,
  fetchCompanies,
  fetchCompanyByUiid,
  fetchJobByFilters,
  fetchProspects,
} from "../../../../redux/slices/leads/leadsApi";
import common from "../../../../utils/common";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { formatWords2 } from "../../../../utils/stringUtils";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { trackEvent } from "../../../../utils/mixpanelService";

const LeadProfile = () => {
  const { loginUserUiid, userData } = useLoginUser();
  const { classifyInput } = common;
  const [searchValue, setSearchValue] = useState("");
  const [filteredCount, setFilteredCount] = useState(0);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [defaultWebsite, setDefaultWebsite] = useState("");
  const [defaultJobLocation, setDefaultJobLocation] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [isLoadingCompany, setIsLoadingCompany] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [selectLocation, setSelectLocation] = useState(null);
  const [isEmptyGoogleResponse, setIsEmptyGoogleResponse] = useState(false);
  const [newJobUiid, setNewJobUiid] = useState(null);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.auth);
  const raSettings = useSelector((state) => state?.leads?.raSettings?.data);

  // selected prospects
  const [selectedProspects, setSelectedProspects] = useState([]);
  const [selectedProspectIds, setSelectedProspectIds] = useState([]);

  const currentCompanyState = useSelector(
    (state) => state.leads.company.current,
  );

  // Debounced search function
  const debouncedSearch = React.useMemo(
    () =>
      debounce(async (value) => {
        if (value.trim() !== "" && value.length >= 2) {
          setIsSearching(true);
          const name = value.trim().toLowerCase();
          const type = classifyInput(name);
          setSearchType(type);
          let results = [];
          let sorted = [];

          try {
            switch (type) {
              case "Email": {
                const response = await fetchProspects({
                  // filters: { "email.primary": { type: "SEARCH", value: name } },
                  filters: { email: { type: "SEARCH", value: name } },
                  limit: 10,
                  page: 1,
                });

                results = (response?.data?.data || []).map((data) => ({
                  ...data,
                  from: "internal",
                }));
                break;
              }
              case "Domain": {
                const response = await fetchCompanies({
                  filters: { domain: { type: "SEARCH", value: name } },
                  limit: 10,
                  page: 1,
                  ret: "uiid name domain industry status addedBy addedOn",
                });

                results = (response?.data?.data || []).map((company) => ({
                  ...company,
                  from: "internal",
                }));
                break;
              }
              case "Company":
              default: {
                const response = await fetchCompanies({
                  // filters: { name: { type: "SEARCH", value: name } },
                  filters: {
                    name: {
                      type: "SEARCH",
                      value: name,
                      addedBy: user?.data?.uiid,
                    },
                  },
                  limit: 100,
                  page: 1,
                  postActions: ["GoogleSearch"],
                  queryMode: "AG_SEARCH_COMPANIES",
                  ret: "uiid name domain industry status addedBy addedOn",
                });
                // if (response?.data?.data?.length > 0) {
                //   results = response.data.data.map((company) => ({
                //     ...company,
                //     from: "internal",
                //   }));
                // }
                // // else {
                // //   const googleResults = response.data?.field?.find(
                // //     (f) => f.action === "GoogleSearch"
                // //   )?.result?.response;

                // //   results = Array.isArray(googleResults)
                // //     ? googleResults.map((companyName) => ({
                // //         name: companyName,
                // //         from: "linkedin",
                // //         uiid: null, // No uiid for external results
                // //       }))
                // //     : [];
                // // }
                // else {
                //   const googleField = response?.data?.field?.find(
                //     (f) => f.action === "GoogleSearch"
                //   );
                //   const googleResult = googleField?.result;
                //   const googleResponse = googleResult?.response;

                //   if (
                //     googleResponse &&
                //     typeof googleResponse === "object" &&
                //     !Array.isArray(googleResponse) &&
                //     googleResponse?.message
                //   ) {
                //     showToast(googleResponse?.message, "info");
                //     results = [];
                //     setIsEmptyGoogleResponse(true);
                //   }
                //   else if (Array.isArray(googleResponse)) {
                //     if (googleResponse?.length === 0) {
                //       setIsEmptyGoogleResponse(true);
                //       showToast("No companies found in Google Search.", "info");
                //       results = [];
                //     } else {
                //       setIsEmptyGoogleResponse(false);
                //       results = googleResponse.map((companyName) => ({
                //         name: companyName,
                //         from: "linkedin",
                //         uiid: null,
                //       }));
                //     }
                //   }
                //   else {
                //     setIsEmptyGoogleResponse(true);
                //   }
                // }
                let internalResults = [];
                let googleResults = [];

                // -------------------------------
                // INTERNAL RESULTS
                // -------------------------------
                if (response?.data?.data && Array.isArray(response.data.data)) {
                  internalResults = response.data.data.map((company) => ({
                    ...company,
                    from: "internal",
                  }));
                }

                // -------------------------------
                // GOOGLE RESULTS
                // -------------------------------
                const googleField = response?.data?.field?.find(
                  (f) => f.action === "GoogleSearch",
                );
                const googleResponse = googleField?.result?.response;

                if (Array.isArray(googleResponse)) {
                  if (googleResponse.length === 0) {
                    setIsEmptyGoogleResponse(true);
                    showToast("No companies found in Google Search.", "info");
                  } else {
                    setIsEmptyGoogleResponse(false);
                    googleResults = googleResponse.map((name) => ({
                      name,
                      from: "linkedin",
                      uiid: null,
                    }));
                  }
                } else if (
                  googleResponse &&
                  typeof googleResponse === "object" &&
                  googleResponse?.message
                ) {
                  showToast(googleResponse.message, "info");
                  setIsEmptyGoogleResponse(true);
                } else {
                  setIsEmptyGoogleResponse(true);
                }

                sorted = [...internalResults, ...googleResults];

                results = sorted.sort((a, b) => {
                  const aStarts = a.name.toLowerCase().startsWith(name);
                  const bStarts = b.name.toLowerCase().startsWith(name);

                  // If both start or both don't start, keep original order
                  if (aStarts === bStarts) return 0;

                  // Items starting with "we" come first
                  return aStarts ? -1 : 1;
                });

                break;
              }
            }
            // console.log("results " ,results)

            const trimmed = value.trim().toLowerCase();

            if (results.length === 0) {
              setSelectedValue(value);
              setCurrentCompany({ uiid: null });
            } else {
              const hasExactMatch = results.some((item) => {
                const name = item?.lowerName || item?.name?.toLowerCase() || "";
                return name === trimmed;
              });

              if (!hasExactMatch) {
                setIsEmptyGoogleResponse(true);
                setSearchData(results);
                setSelectedValue(value);
                setCurrentCompany({ uiid: null });
              }
            }
            setSearchResults(results);
          } catch (err) {
            console.error("Search error:", err);
            setSearchResults([]);
          } finally {
            setIsSearching(false);
          }
        } else {
          setSearchResults([]);
          setIsSearching(false);
        }
      }, 300),
    [classifyInput],
  );

  // console.log("searchResults",searchResults);

  const toggleAddAccountModal = async (manual = false) => {
    if (!searchValue.trim()) {
      return;
    }
    setIsLoadingCompany(true);
    try {
      const payload = {
        coll: "Company",
        payload: {
          name: searchValue.trim().toLowerCase(), // Using .toLowerCase() correctly
          addedBy: user?.data?.uiid, // Assuming user.data.uiid is valid
          approval: {
            isEnabled: manual || isEmptyGoogleResponse ? true : false,
          },
        },
      };

      const response = await addCompanyApi({ payload });
      if (response?.success) {
        const payload = {
          coll: "Job",
          postActions: ["AddToProspect"], // no Prospects
          payload: {
            // title: "",
            // description: "",
            // location: {},
            // industry: "",
            // website: "",
            addedBy: user?.data?.uiid,
            companyId: response?.data?.data?.uiid,
          },
        };

        dispatch(
          addJobStart({
            payload,
            onSuccess: (response) => {
              trackEvent({eventName:"Company_created",props:{
                name:searchValue?.trim()?.toLowerCase()
              }})
              setNewJobUiid(response?.data?.data?.uiid);
              showToast("Company added successfully!", "success", 2000);
              setShowAddAccountModal(true);
              const data = response?.data?.data || {}; // Defaulting to an empty object if no data
              const approval = data?.approval;
              const approvalFlag =
                approval?.isEnabled === true &&
                (approval?.status === 1 || approval?.status === 3);
              setCurrentCompany((prevState) => ({
                ...prevState,
                ...data,
                approvalFlag,
              }));
              setIsLoadingCompany(false);
            },
          }),
        );
      } else {
        const err = response?.error;
        if (err?.errorResponse?.code === 11000) {
          const duplicateName = err?.errorResponse?.keyValue?.name;
          showToast(
            `Company "${duplicateName}" already exists.`,
            "error",
            3000,
          );
        } else {
          showToast("Failed to add company. Please try again.", "error", 3000);
        }

        setIsLoadingCompany(false);
      }
    } catch (error) {
      showToast("Failed to add company. Please try again.", "error", 2000);
      setIsLoadingCompany(false);
    }
  };
  // const toggleAddAccountModal = async (manual=false) => {
  //   if (!searchValue.trim()) {
  //     return;
  //   }
  //   setIsLoadingCompany(true);
  //   try {
  //     const payload = {
  //       coll: "Company",
  //       payload: {
  //         name: searchValue.trim().toLowerCase(), // Using .toLowerCase() correctly
  //         addedBy: user.data.uiid, // Assuming user.data.uiid is valid
  //         approval: {
  //         isEnabled: manual || isEmptyGoogleResponse ? true : false
  //       }
  //       },
  //     };

  //     const response = await addCompanyApi({ payload });
  //     if (response?.success) {
  //       showToast("Company added successfully!", "success", 2000);
  //       setShowAddAccountModal(true);
  //       const data = response?.data?.data || {}; // Defaulting to an empty object if no data
  //       const approval = data?.approval;
  //       const approvalFlag =
  //         approval?.isEnabled === true &&
  //         (approval?.status === 1 || approval?.status === 3);
  //       setCurrentCompany((prevState) => ({ ...prevState, ...data,approvalFlag }));
  //       setIsLoadingCompany(false);
  //     } else {
  //       setIsLoadingCompany(false);
  //     }
  //   } catch (error) {
  //     showToast("Failed to add company. Please try again.", "error", 2000);
  //     setIsLoadingCompany(false);
  //   }
  // };

  const closeAccountModal = (runApi = false) => {
    const payload = {
      coll: "Job",
      postActions: ["AddToProspect"], // no Prospects
      payload: {
        addedBy: user?.data?.uiid,
        companyId: currentCompany?.uiid,
      },
    };

    !runApi &&
      dispatch(
        addJobStart({
          payload,
          onSuccess: () => {
             trackEvent({eventName:"Company_created",props:{
                name:searchValue?.trim()?.toLowerCase()
              }})
          },
        }),
      );

    setSearchValue("");
    setCurrentCompany(null);
    setSelectedValue("");
    setShowAddAccountModal(false);
    setSearchResults([]);
    setSelectedProspectIds([]);
    setSelectedProspects([]);
  };

  // Fixed handleSelectSuggestion function
  const handleSelectSuggestion = async (value) => {
    if (value?.name && searchData.length > 0) {
      const trimmed = value?.name.trim().toLowerCase();

      const hasExactMatch = searchData.some((item) => {
        const name = item?.lowerName || item?.name?.toLowerCase() || "";
        return name === trimmed;
      });

      if (hasExactMatch) {
        setIsEmptyGoogleResponse(false);
      }
    }
    setSelectedValue(searchType == "Email" ? value?.email?.email : value?.name);
    setSearchValue(searchType == "Email" ? value?.email?.email : value?.name);
    setSearchResults([]); // Clear search results
    // Case 1: Item has uiid - fetch company data from DB
    if (value?.uiid) {
      setIsLoadingCompany(true);
      const selectCompanyId =
        searchType == "Email" ? value?.companyId : value?.uiid;
      try {
        // const filters = { uiid: { type: "NONE", value: selectCompanyId} };
        const filters = { uiid: { type: "COMPANY_SEARCH", value: searchType==="Company" ?null: selectedValue?.toLocaleLowerCase()?.trim(), uiid: selectCompanyId,searchType } };
        const response = await fetchCompanyByUiid({
          filters,
          // ref: "JobsWithProspect",
          extret: "uiid firstName",
          aggregate:true // 
        });
        const extractedData = response?.data?.data[0] || {};
        if (response?.success && extractedData) {
          // Company found with data
          const company = extractedData;
          const approvalFlag = {
            isEnabled: company?.approval?.isEnabled,
            status: company?.approval?.status,
          };
          // setCurrentCompany(response.data.data);
          setCurrentCompany({
            ...company,
            approvalFlag,
          });
        } else {
          // Company exists but no job/prospect data
          setCurrentCompany(null);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
        setCurrentCompany(null);
      } finally {
        setIsLoadingCompany(false);
      }
    } else {
      // Case 2: Item has no uiid - external result (LinkedIn, etc.)
      setCurrentCompany({ ...value });
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    // const value = e.target.value;

    const normalizeInput = (str) =>
      str.replace(/^\s+/, "").replace(/\s+/g, " ");

    const value = normalizeInput(e.target.value);
    // console.log("value", value);

    setSearchValue(value);
    // debouncedSearch(value);
    debouncedSearch(value.trim());

    // Clear current company and selection if value changes
    if (value !== selectedValue) {
      setCurrentCompany(null);
      setSelectedValue("");
    }

    if (!value.trim()) {
      setSearchResults([]);
      setCurrentCompany(null);
      setSelectedValue("");
    }
  };

  // const handleAddJobClick = ({ show, website, location }) => {
  //   setShowAddAccountModal(show);
  //   setDefaultWebsite(website);
  //   // setDefaultJobLocation(location);

  //   // remove the Add Job button flag
  //   setCurrentCompany((prev) => ({
  //     ...prev,
  //     noJobsInLocation: false,
  //   }));
  // };
  const handleAddJobClick = ({ show, website, location }) => {
    const payload = {
      coll: "Job",
      postActions: ["AddToProspect"], // no Prospects
      payload: {
        title: "",
        description: "",
        location: {},
        industry: "",
        website: "",
        addedBy: user?.data?.uiid,
        companyId: currentCompany?.uiid,
      },
    };

    dispatch(
      addJobStart({
        payload,
        onSuccess: (response) => {
          setNewJobUiid(response?.data?.data?.uiid);
           trackEvent({eventName:"Company_created",props:{
                name:searchValue?.trim()?.toLowerCase()
              }})
          setShowAddAccountModal(true);
          // setDefaultWebsite(website);
          // setDefaultJobLocation(location);

          // remove the Add Job button flag
          setCurrentCompany((prev) => ({
            ...prev,
            noJobsInLocation: false,
          }));
        },
      }),
    );
  };

  const colRADetails = [
    {
      key: "name",
      label: "RA Name",
      columnMenu: false,
    },
    {
      key: "addedOn",
      label: "Added On",
      render: (row) => {
        const { addedOn } = row;
        return addedOn ? dateFormator(addedOn) : "";
      },
      columnMenu: false,
    },
    {
      key: "jobTitle",
      label: "Job Title",
      columnMenu: false,
    },
    {
      key: "jobLocation",
      label: "Job Location",
      columnMenu: false,
    },
    {
      key: "jobDescription",
      label: "Job Description",
      render: (row) => {
        const { jobDescription } = row;
        // return (jobDescription && jobDescription !== "") ? (
        //   <a
        //     href={jobDescription}
        //     target="_blank"
        //     rel="noopener noreferrer"
        //     className="text-blue-600 hover:underline cursor-pointer"
        //   >
        //     Link
        //   </a>
        // ) : (
        //   ""
        // );
        return jobDescription && jobDescription !== "-" ? (
          <a
            href={jobDescription}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline cursor-pointer"
          >
            Link
          </a>
        ) : (
          "-"
        );
      },
      columnMenu: false,
    },
  ];

  const colContactDetails = [
    {
      key: "name",
      label: "Full Name",
      render: (row) => {
        const { name } = row;
        if (typeof name === "object" && name !== null) {
          return `${formatWords2(name.firstName || "")} ${formatWords2(name.middleName || "")}`.trim();
        }
        return name || "";
      },
      columnMenu: false,
    },
    {
      key: "designation",
      label: "Designation",
      columnMenu: false,
    },
    {
      key: "location",
      label: "Location",
      columnMenu: false,
    },
    {
      key: "email",
      label: "Email",
      columnMenu: false,
      render: (row) => {
        const { email, status } = row;
        const emailStatus = {
          Verified: "success",
          Positive: "success-300",
          DND: "danger",
          "No Follow-up": "dark",
          Blocked: "danger",
          "Not Verified": "primary",
        };
        return email ? (
          <div
            className={`flex items-center gap-0.5 text-${emailStatus[status]}`}
          >
            <CopyToClipboard
              content={email}
              title={email}
              color={emailStatus[status]}
            />
            {email}
            {status === "Verified" && (
              <div className="ml-2 w-3 h-3 rounded-full bg-success  flex items-center justify-center">
                <span className="material-symbols-outlined text-white !text-[10px]">
                  check
                </span>
              </div>
            )}
            {status === "Positive" && (
              <div className="ml-2 w-3 h-3 rounded-full bg-white  flex items-center justify-center">
                <span className="material-symbols-outlined text-success-300 !text-[14px]">
                  mark_email_read
                </span>
              </div>
            )}
          </div>
        ) : (
          ""
        );
      },
    },
    {
      key: "phone",
      label: "Phone",
      columnMenu: false,
      render: (row) => {
        const { phone } = row;
        return phone ? (
          <div className="flex items-center gap-0.5">
            <CopyToClipboard content={phone} title={phone} />
            {phone}
          </div>
        ) : (
          ""
        );
      },
    },
  ];

  const statusList = ["Positive", "Verified", "DND", "Not Verified"];
  const companyStatus = {
    1: "Active",
    2: "Blocked",
  };
  const getLockInPeriod = ({ addedOn, lockDays, text = false }) => {
    if (!addedOn) return true;
    const addedDate = new Date(addedOn);
    const today = new Date();
    const diffTime = today - addedDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    // console.log(lockDays)
    // console.log(diffDays)
    // console.log(addedOn)
    return diffDays >= lockDays
      ? text
        ? "Company Unlocked"
        : true
      : text
        ? `${lockDays - diffDays} days left to unlock`
        : false;
  };

  // Updated logic for showing company details and add button
  const showCompanyDetails =
    currentCompany && currentCompany?.uiid && selectedValue === searchValue;

  const showAddAccount =
    !isSearching && // not currently searching
    !isLoadingCompany && // not loading company data
    currentCompany && // company is selected
    !currentCompany?.uiid && // but has no job/prospect data
    selectedValue === searchValue;
  if (showAddAccount) {
    console.log("Condition for showAddAccount is true");
  }

  const handleLocationChange = async (locationValue) => {
    if (!currentCompany) return;

    setSelectLocation(locationValue);
    const [cityRaw, stateRaw] = (locationValue || "").split("-");
    const city = cityRaw?.trim();
    const state = stateRaw?.trim();

    try {
      setIsLoadingCompany(true);
      const response = await fetchJobByFilters({
        companyId: currentCompany?.uiid,
        state,
        city,
        ref: "Propects",
      });

      const jobs = response?.data || [];

      if (jobs?.length > 0) {
        setCurrentCompany({
          ...currentCompany,
          jobIds: jobs,
          noJobsInLocation: false,
          selectedLocation: locationValue, // no button needed
        });
      } else {
        // no jobs exist → show Add Job button instead of opening modal
        setCurrentCompany({
          ...currentCompany,
          jobIds: [],
          noJobsInLocation: true, // flag to show button
          selectedLocation: locationValue, // store selected location
        });
      }
    } catch (err) {
      console.error("Error fetching jobs by location:", err);
    } finally {
      setIsLoadingCompany(false);
    }
  };

  function extractJobAndProspects(doc) {
    const jobIds = [];
    const prospectIds = [];
    if (!doc) return { jobIds, prospectIds };
    if (Array.isArray(doc.jobIds)) {
      for (const job of doc.jobIds) {
        jobIds.push(job);
        if (Array.isArray(job.prospectIds)) {
          prospectIds.push(...job.prospectIds);
        }
      }
    }
    return { jobIds, prospectIds };
  }
  const EMAIL_STATUS_MAP = {
    1: "Not Verified",
    2: "Verified",
    3: "Invalid",
  };

  const INPERSON_STATUS_MAP = {
    1: "Not Responded",
    2: "Positive",
    3: "DND",
  };

  const getProspectStatus = (prospect) => {
    if (prospect?.inpersonResponseStatus !== 1) {
      return INPERSON_STATUS_MAP[prospect?.inpersonResponseStatus] || "Unknown";
    }
    // return EMAIL_STATUS_MAP[prospect.emailVerificationStatus] || "Unknown";
    return EMAIL_STATUS_MAP[prospect?.email?.status] || "Unknown";
  };
  const { jobIds, prospectIds } = extractJobAndProspects(currentCompany);
  const uniqueProspects = Array.from(
    new Map(prospectIds.map((item) => [item.uiid, item])).values(),
  );
  // below map is only for prioritizing contact status in sorting not for values
  const CONTACT_STATUS_PRIORITY = {
    Positive: 1,
    Verified: 2,
    "Not Verified": 3,
    DND: 4,
  };
  const rowsContactDetails =
    uniqueProspects
      .map((prospect) => ({
        id: prospect?._id,
        name: {
          firstName: prospect?.firstName || "",
          middleName: prospect?.lastName || "",
        },
        addedOn: prospect?.addedOn,
        designation: formatWords2(prospect?.designation || "N/A"),
        // location: prospect.location
        //   ? `${prospect.location.city || ""}, ${prospect.location.state || ""}, ${prospect.location.country || ""
        //     }`.trim()
        //   : "N/A",
        location: prospect?.location
          ? [
            prospect?.location?.city,
            prospect?.location?.state,
            prospect?.location?.country,
          ]
            .filter(Boolean)
            .join(", ") || "N/A"
          : "N/A",
        email: prospect?.email?.email || prospect?.email || "",
        // phone: prospect.mobile?.primary
        //   ? `${prospect.mobile.primary.code} ${prospect.mobile.primary.number}`
        //   : "",
        phone: prospect?.mobile
          ? `${prospect?.mobile?.code || ""} ${prospect?.mobile?.number || ""}`.trim()
          : "",

        // status:
        //   prospect.status === 1
        //     ? "Verified"
        //     : prospect.status === 3
        //       ? "Not Verified"
        //       : "Unknown",
        status: getProspectStatus(prospect),
        inpersonResponseStatus: prospect?.inpersonResponseStatus || "",
      }))
      // .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn)) || [];
      .sort((a, b) => {
        const statusDiff =
          (CONTACT_STATUS_PRIORITY[a.status] || 99) -
          (CONTACT_STATUS_PRIORITY[b.status] || 99);

        if (statusDiff !== 0) return statusDiff;

        return new Date(b.addedOn) - new Date(a.addedOn);
      });

  const rowRADetails = jobIds
    .map((data) => {
      return {
        id: data?._id,
        name: formatWords2(data.addedBy?.firstName || ""),
        uiid: data?.uiid,
        addedOn: convertFromUTC(data?.addedOn) || "",
        jobTitle: formatWords2(data?.title || ""),
        // jobLocation: data.location
        //   ? `${data.location.city || ""}, ${data.location.state || ""}, ${data.location.country || ""
        //     }`.trim()
        //   : "N/A",
        jobLocation: data?.location
          ? [
            data?.location?.city,
            data?.location?.state,
            data?.location?.country,
          ]
            .filter(Boolean)
            .join(", ") || "N/A"
          : "N/A",
        jobDescription: data?.description || "",
      };
    })
    .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn));
  const mappedRowsRADetails = mapTableRows(rowRADetails, colRADetails);
  const mappedRowsContactDetails = mapTableRows(
    rowsContactDetails,
    colContactDetails,
  );

  const lockInPeriodTime = getLockInPeriod({
    addedOn: jobIds[jobIds.length - 1]?.addedOn,
    lockDays: raSettings?.[0]?.raSetting?.waitingPeriod,
    text: true,
  });

  useEffect(() => {
    dispatch(
      getRaSettingsStart({
        coll: "Setting",
        lim: 10,
        pg: 1,
        ret: "raSetting uiid",
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    setSelectedProspectIds([]);
  }, []);
  const parsePhone = (phone) => {
    if (!phone) return { code: "", number: "" };

    if (typeof phone === "object") {
      return {
        code: phone.code || "",
        number: phone.number || "",
      };
    }

    if (typeof phone === "string") {
      const parts = phone.trim().split(/\s+/);
      const code = parts[0] || "";
      const number = parts.slice(1).join(" ") || "";
      return { code, number };
    }

    return { code: "", number: "" };
  };

  const parseLocationForPrefill = (locationString) => {
    if (
      !locationString ||
      typeof locationString !== "string" ||
      locationString.trim() === "" ||
      locationString.trim() === "N/A"
    ) {
      return { label: "", value: "" };
    }

    const parts = locationString.split(",").map((s) => s.trim());

    if (parts.length >= 2) {
      const city = parts[0];
      const state = parts[1];

      if (parts.length === 2 && !city.includes(" ")) {
        return { label: state || city, value: state || city };
      }

      return {
        label: `${city} - ${state}`,
        value: `${city} - ${state}`,
      };
    }

    return {
      label: locationString.trim(),
      value: locationString.trim(),
    };
  };

  const onSelectionChange = (e) => {
    const nonDndSelected = rowsContactDetails.filter(
      (item) => e.includes(item?.id) && item?.status !== "DND"
    );
    if (nonDndSelected.length > 5) {
      showToast("You can select a maximum of 5 contacts.", "info");
      // return setSelectedProspectIds([...selectedProspectIds]);
      const cappedIds = nonDndSelected.slice(0, 5).map(item => item.id);
      return setSelectedProspectIds(cappedIds);
    }

    const selectedOnes = rowsContactDetails
      // .slice(0, 5)
      .filter((item) => e.includes(item?.id) && item?.status !== "DND")
      // .map(item => ({
      //   id: item?.id,
      //   firstName: item?.name?.firstName,
      //   lastName: item?.name?.middleName,
      //   email: item?.email?.email || item?.email,
      //   location: item?.location,
      //   designation: item?.designation,
      //   mobile: { code: item?.phone?.code, number: item?.phone?.number },
      //   //  id: uuidv4(),
      // }));
      .map((item) => {
        const { code, number } = parsePhone(item?.phone);
        return {
          id: item?.id,
          firstName: item?.name?.firstName,
          lastName: item?.name?.middleName,
          email: item?.email?.email || item?.email,
          contactLocation: parseLocationForPrefill(item?.location),
          designation: item?.designation,
          phone: { code, number },
        };
      });
    const selectedIds = rowsContactDetails
      .filter(
        (item) =>
          e.includes(item?.id) && !["DND", "Invalid"].includes(item?.status),
      )
      .map((item) => item.id);

    setSelectedProspects(selectedOnes);
    setSelectedProspectIds(selectedIds);
  };

  const handleManualSearch = async () => {
    if (searchValue.trim() === "") return;
    debouncedSearch.cancel();
    debouncedSearch(searchValue);
    setSearchResults([]);
    await debouncedSearch.flush?.();
  };

  // const handleManualSearch = async () => {
  //   if (!searchValue.trim()) return;
  //   await performSearch(searchValue);
  // };

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     handleManualSearch();
  //   }
  // };
  const trimmed = searchValue?.trim().toLowerCase();

  const nameExists = searchResults.some(
    (item) => item.name?.toLowerCase() === trimmed,
  );
  return (
    <div className="flex-1">
      <CustomSearchNew
        value={searchValue}
        onChange={handleInputChange}
        onFilteredCountChange={(count) => setFilteredCount(count)}
        names={searchResults}
        onSelect={handleSelectSuggestion}
        searchType={searchType}
        // onKeyDown={handleKeyDown}
        onSearch={() => handleManualSearch()}
        showAddButton={
          searchType === "Company" &&
          !isSearching &&
          !isLoadingCompany &&
          searchResults.length > 0 &&
          !nameExists
        }
        setIsEmptyGoogleResponse={setIsEmptyGoogleResponse}
        toggleAddAccountModal={toggleAddAccountModal}
        debouncedSearch={debouncedSearch}
      />

      <>
        {showCompanyDetails ? (
          <>
            <div className="w-full flex justify-center">
              <div className="w-full max-w-7xl">
                <AccountCard
                  data={{
                    accountName: currentCompany?.name,
                    accountStatus:
                      companyStatus[currentCompany?.status] || "Unknown",
                    industry: formatWords2(currentCompany?.industry || "N/A"),
                    website: currentCompany?.domain || "N/a",
                    // lastAddedBy: jobIds[jobIds.length - 1]?.addedBy,
                    lastAddedBy:
                      formatWords2(jobIds[jobIds.length - 1]?.addedBy?.firstName ||
                        currentCompany?.addedBy?.firstName ||
                        ""),
                    lastAddedOn:
                      jobIds[jobIds.length - 1]?.addedOn ||
                      currentCompany?.addedOn ||
                      "",
                    accountApproval: currentCompany?.approval?.status || "-",
                    lastJobStatus: jobIds[jobIds.length - 1]?.status || 1,
                    lockInPeriod: getLockInPeriod({
                      addedOn:
                        jobIds[jobIds.length - 1]?.addedOn ||
                        currentCompany?.addedOn,
                      // lockDays: 18,
                      lockDays: raSettings?.[0]?.raSetting?.waitingPeriod,
                      text: true,
                    }),
                    // location: jobIds[jobIds.length - 1]?.location
                    //   ? `${jobIds[jobIds.length - 1].location.city || ""}-${jobIds[jobIds.length - 1].location.state || ""
                    //   }`
                    //   : selectLocation,
                    location: jobIds[jobIds.length - 1]?.location
                      ? (jobIds[jobIds.length - 1].location.city != null && jobIds[jobIds.length - 1].location.state != null) ? [
                        jobIds[jobIds.length - 1].location.city,
                        jobIds[jobIds.length - 1].location.state,
                      ]
                        .filter(Boolean)
                        .join("-") : "N/a"
                      : selectLocation ,
                  }}
                  onLocationChange={handleLocationChange}
                  currentCompany={currentCompany}
                  handleAddNewLoc={handleAddJobClick}
                  lastJobStatus={jobIds[jobIds.length - 1]?.status || 1}
                  // lockInPeriodTime={getLockInPeriod({
                  //   addedOn: jobIds[jobIds.length - 1]?.addedOn,
                  //   // lockDays: 18,
                  //   lockDays: raSettings?.[0]?.raSetting?.lockPeriodDays || 18,
                  // })}
                  // lockInPeriodTime={getLockInPeriod({
                  //   addedOn: jobIds[jobIds.length - 1]?.addedOn,
                  //   lockDays: raSettings?.[0]?.raSetting?.waitingPeriod, // use backend value directly
                  //   text: true,
                  // })}
                  lockInPeriodTime={getLockInPeriod({
                    addedOn:
                      jobIds[jobIds.length - 1]?.addedOn ||
                      currentCompany?.addedOn,
                    // lockDays: raSettings?.[0]?.raSetting?.waitingPeriod||18,
                    lockDays: raSettings?.[0]?.raSetting?.waitingPeriod,
                    text: false,
                  })}
                  //chnage3

                  raSetting={raSettings?.[0]?.raSetting}
                  setCurrentCompany={setCurrentCompany}
                />
              </div>
            </div>
            <div className="w-full overflow-hidden flex 2xl:flex-row md:flex-col gap-10 mt-7 flex-1">
              {jobIds.length > 0 && (
                <div className="flex flex-1 flex-col overflow-auto">
                  <div>
                    <h6 className="header">RA Details</h6>
                  </div>
                  <TableAdv
                    columns={colRADetails}
                    rows={mappedRowsRADetails}
                    info={"info"}
                    limit={5}
                    selectList={[5, 10, 15]}
                    tdClassName="!py-3"
                    toolbarRight={{
                      search: false,
                      filter: false,
                      download: false,
                    }}
                  />
                </div>
              )}
              {prospectIds?.length > 0 && (
                <div className="flex flex-1 flex-col overflow-auto">
                  <div>
                    <h6 className="header">Contact Details</h6>
                  </div>
                  <TableAdv
                    limit={5}
                    selectList={[5, 10, 15]}
                    columns={colContactDetails}
                    rows={mappedRowsContactDetails}
                    onSelectionChange={onSelectionChange}
                    defaultSelectedRows={selectedProspectIds}
                    showCheckbox
                    info={"info"}
                    tdClassName="!py-3"
                    toolbarRight={{
                      search: false,
                      filter: false,
                      download: false,
                      add: [
                        {
                          component: (
                            <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                              {statusList.map((item) => {
                                const status = {
                                  Positive: "success-300",
                                  Verified: "success",
                                  DND: "danger",
                                  "No Follow-up": "dark",
                                  Blocked: "danger",
                                  "Not Verified": "primary",
                                };
                                return (
                                  <div
                                    key={item}
                                    className="flex items-center gap-1"
                                  >
                                    <div
                                      className={`w-2 h-2 rounded-full bg-${status[item]}`}
                                    ></div>
                                    <div>{item}</div>
                                  </div>
                                );
                              })}
                            </div>
                          ),
                        },
                      ],
                    }}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          showAddAccount && (
            <div className="flex justify-center items-center flex-col gap-2 mb-10">
              <div>No Details Found under this Account.</div>
              <div>
                <Button
                  title={"Add Account"}
                  icon={"add"}
                  onClick={() => toggleAddAccountModal()}
                />
              </div>
            </div>
          )
        )}
        <Modal
          isOpen={showAddAccountModal}
          onClose={closeAccountModal}
          width="w-full"
          title={`${formatWords2(currentCompany?.name || searchValue)}`}
          showCloseButton={false}
        >
          <AddAccount
            onClose={() => {
              closeAccountModal(true);
              setSelectedProspectIds([]);
              setSelectedProspects([]);
            }}
            defaultWebsite={defaultWebsite}
            defaultJobLocation={defaultJobLocation}
            currentCompany={currentCompany}
            //change1
            raSetting={raSettings?.[0]?.raSetting}
            selectedProspects={selectedProspects}
            enableLocationRestrictionCheck={true}
            approvalFlag={currentCompany?.approvalFlag}
            newJobUiid={newJobUiid}
          />
        </Modal>
        <Backdrop isOpen={isLoadingCompany}>
          <LogoLoader />
        </Backdrop>
      </>
    </div>
  );
};

export default LeadProfile;
